import { createActionColumn } from "../../../shared/actionColumn";
import { deleteTransaction } from "@services/api";

export const getColumnDefs = (
  handleCellValueChanged: (params: any) => Promise<void>,
  handleDeleteSuccess: () => Promise<void>,
) => [
  {
    headerName: "ID",
    field: "id",
    sortable: true,
    width: 60,
    suppressMovable: true,
    resizable: false,
  },
  {
    headerName: "Имя участника",
    field: "name",
    sortable: true,
    filter: true,
    resizable: false,
    width: 200,
    suppressMovable: true,
  },
  {
    headerName: "Сумма",
    field: "amount",
    sortable: true,
    filter: false,
    resizable: false,
    editable: true,
    flex: 1,
    width: 80,
    suppressMovable: true,
    onCellValueChanged: handleCellValueChanged,
  },
  {
    headerName: "Дата",
    field: "date",
    sortable: true,
    sort: "desc",
    filter: true,
    resizable: false,
    editable: true,
    width: 125,
    suppressMovable: true,
    onCellValueChanged: handleCellValueChanged,
  },
  {
    headerName: "Тип",
    field: "type",
    sortable: true,
    filter: true,
    resizable: false,
    editable: true,
    width: 150,
    suppressMovable: true,
    onCellValueChanged: handleCellValueChanged,
  },
  {
    headerName: "Описание",
    field: "description",
    sortable: true,
    filter: true,
    resizable: false,
    editable: true,
    flex: 2,
    minWidth: 150,
    suppressMovable: true,
    onCellValueChanged: handleCellValueChanged,
  },
  createActionColumn({
    icon: "X",
    type: "delete",
    onClick: (data) => {
      deleteTransaction(data.id)
        .then(() => {
          handleDeleteSuccess();
        })
        .catch((error) => {
          console.error("Ошибка:", error);
          alert("Ошибка удаления транзакции");
        });
    },
  }),
];

export const staticColumnDefs = [
  {
    headerName: "ID",
    field: "id",
    sortable: true,
    width: 60,
    suppressMovable: true,
    resizable: false,
  },
  {
    headerName: "Имя участника",
    field: "name",
    sortable: true,
    filter: true,
    resizable: false,
    width: 200,
    suppressMovable: true,
  },
  {
    headerName: "Сумма",
    field: "amount",
    sortable: true,
    filter: false,
    resizable: false,
    flex: 1,
    width: 80,
    suppressMovable: true,
  },
  {
    headerName: "Дата",
    field: "date",
    sortable: true,
    sort: "desc",
    filter: true,
    resizable: false,
    width: 100,
    suppressMovable: true,
  },
  {
    headerName: "Тип",
    field: "type",
    sortable: true,
    filter: true,
    resizable: false,
    width: 150,
    suppressMovable: true,
  },
  {
    headerName: "Описание",
    field: "description",
    sortable: true,
    filter: true,
    resizable: false,
    flex: 2,
    minWidth: 150,
    suppressMovable: true,
  },
];
